import * as React from 'react';
import { SVGProps } from 'react';

const IconBitSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9 5a1 1 0 0 0-1 1v2L4.598 9.701 4.4 9.75v.068a1 1 0 0 0-.4.8v6.642l-2 .99C2 20.873 4.149 23 6.8 23h.4l.8-2h3.5l.9 2h3.2l.9-2H20l.8 2h.4c2.651 0 4.8-2.127 4.8-4.75l-2-.99v-6.642a1 1 0 0 0-.4-.8V9.75l-.198-.049L20 8V6a1 1 0 0 0-1-1H9Z" />
  </svg>
);
export default IconBitSizeL;
